var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ChangeDetectorRef, ElementRef, EventEmitter, Renderer } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MaskPipe } from 'ngx-mask';
import { Modal } from 'ngx-modal';
import { environment } from '../../../../environments/environment';
import { ContactTypeValue } from '../../../common/enums/contact-type.value.enum';
import { CacheService } from '../../../shared/services/cache.service';
import { CacheKey } from '../../../shared/constants/cachekey.constants';
import { CommonService } from '../../../shared/services/common.service';
import { MessageService } from '../../../shared/services/message.service';
import { CountrySuffixZipCodes } from '../../constants/country-suffix-zipcodes';
import { AddressError } from '../../enums/address-error.enum';
import { AddressOptions, AddressSchemaFormFrameworkType } from '../../enums/address-type.enum';
import { NotificationType } from '../../enums/notification-types.enum';
import { SchemaProperty } from '../../enums/schema-property.enum';
import { AddressService } from '../../services/address.service';
import { CheckoutConfigService } from '../../services/checkout-config.service';
import { CustomerService } from '../../services/customer.service';
import { CustomMaskTextboxComponent } from '../../widgets/custom-mask-textbox.widget';
import { CustomSelectWidgetComponent } from '../../widgets/custom-select.widget';
import { TranslateKey } from './../../../common/pipes/translate-key.pipe';
var AddressNewComponent = /** @class */ (function () {
    function AddressNewComponent(_addressService, elementRef, _renderer, _commonService, _customerService, _checkoutConfigService, chRef, _translateService, _maskPipe, messageService, _translateKey, _appMessageService, _cacheService) {
        this._addressService = _addressService;
        this.elementRef = elementRef;
        this._renderer = _renderer;
        this._commonService = _commonService;
        this._customerService = _customerService;
        this._checkoutConfigService = _checkoutConfigService;
        this.chRef = chRef;
        this._translateService = _translateService;
        this._maskPipe = _maskPipe;
        this.messageService = messageService;
        this._translateKey = _translateKey;
        this._appMessageService = _appMessageService;
        this._cacheService = _cacheService;
        this.selectedFrameWork = AddressSchemaFormFrameworkType.BOOTSTRAP4;
        this.addressVerificationForm = false;
        this.responseCodes = [];
        this.errorCodesLength = 0;
        this.isModalOpen = false;
        this.jsonFormOptions = {
            addSubmit: true,
            loadExternalAssets: false,
            debug: false,
            setSchemaDefaults: true,
            returnEmptyFields: false,
        };
        this.customWidgets = {
            'custom-select-widget': CustomSelectWidgetComponent,
            'custom-mask-widget': CustomMaskTextboxComponent
        };
        this.selectedAddressType = AddressOptions.SUGGESTEDADDRESS;
        this.displayAddressBlock = true;
        this.validationMessageInitialHide = true;
        this.pollCount = 0;
        this.maxpollCount = 1;
        this.addressSubmit = new EventEmitter();
        // this is used to send info of displaying address verification
        // as of now we are using in personal information section
        this.addressVerificationInfo = new EventEmitter();
        this.addressSubmitOnInputChange = new EventEmitter();
        this.addressHidden = new EventEmitter();
        this.addressInputChanged = new EventEmitter();
        this.cancelChangeAddress = new EventEmitter();
        this.isDisplaySearchAddressSection = new EventEmitter();
        this.liveFormStatusIsValid = new EventEmitter();
    }
    AddressNewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isoCountryCode = this.countryCode;
        this.checkoutConfig = this._checkoutConfigService.getSettings(this.countryCode, null);
        if (this.isShippingAddressSchemaform && this.checkoutConfig && this.checkoutConfig.changeSchemaFormOnCountryChange) {
            this.changeSchemaOnCountryChange(true);
        }
        this.getCountriesLookup();
        this.getCustomSelectOption();
        this.getJsonSchema();
        this.rebindForm();
        this.enableAddressFields();
        this._commonService.getEmitter('newAddressForm').subscribe(function (response) {
            _this.reloadJsonObject();
        });
        if (this.checkoutConfig && this.checkoutConfig.loadParticipatingCountries) {
            this.getParticipatingCountries();
        }
        this.getSubmitAddress();
    };
    /**
     * @description new Address Schema Form
     * @date 2018-07-20
     * @private
     * @memberof AddressComponent
     */
    AddressNewComponent.prototype.reloadJsonObject = function () {
        this.address = null;
        this.jsonFormObject = {};
        this.jsonFormObject.data = {};
        this.jsonFormObject = this.getParsedSchemaFormJson(this.originalJsonFormObject);
    };
    /**
     * @param {Address} data
     * @memberof AddressNewComponent
     */
    AddressNewComponent.prototype.onChanges = function (data) {
        this.liveFormData = data;
    };
    /**
     * @description it will trigger when we
     * change any input value in form
     * @date 2018-08-02
     * @memberof AddressComponent
     */
    AddressNewComponent.prototype.changeInputValue = function (event) {
        // To notify address is changed by the User
        this.addressInputChanged.emit(true);
        this.messageService.setAddressSaved(false);
        if (this.addressVerificationForm) {
            this.isAddressFormChanged = true;
        }
        this.showAddressVerification = true;
        if ($('.remove-disable').attr('disabled')) {
            $('.remove-disable').removeAttr('disabled');
        }
        // logic to enable submit button in popup.
        this.jsonFormObject = this.enableVerifyButton();
        if (this.isInputChangeRequired) {
            this.addressSubmitOnInputChange.emit(this.prepareNewAddress(this.liveFormData));
        }
    };
    /**
     * @description method to get countries lookup
     * @memberof AddressNewComponent
     */
    AddressNewComponent.prototype.getCountriesLookup = function () {
        var countryCode = this.getShippingCountryCode();
        var allCountries = JSON.parse(localStorage.getItem("appadmin.Countries"));
        if (allCountries && allCountries.length > 0) {
            this.countries = allCountries;
            var country = this.countries.find(function (x) { return x.isocodeThree === countryCode.toUpperCase(); });
            if (country && country.countryId) {
                this.countryId = country.countryId;
                this.getAllStatesByCountry();
            }
        }
    };
    AddressNewComponent.prototype.getShippingCountryCode = function () {
        if (this.checkoutConfig.isParticipatingCountryShippingEnabled || this.isShippingAddressSchemaform) {
            if (this.participatingCountry && this.participatingCountry.isocodeThree) {
                return this.participatingCountry.isocodeThree;
            }
            else if (this.preloadAddress && this.preloadAddress.countryCode) {
                return this.preloadAddress.countryCode;
            }
        }
        return this.isoCountryCode;
    };
    /**
     * @description
     * @date 2020-03-23
     * @private
     * @memberof AddressNewComponent
     */
    AddressNewComponent.prototype.getParticipatingCountries = function () {
        var _this = this;
        this._customerService.getParticipatingCountries(this.countryCode)
            .subscribe(function (response) {
            if (response && response.length > 0) {
                _this.participatingCountries = response;
            }
        });
    };
    /**
     * to get latitude and longitude info for GBR
     * @returns void
     */
    AddressNewComponent.prototype.getSpatialInfo = function () {
        var _this = this;
        var postalCode = this.address.zip || this.address.postalCode;
        var countryCode = this.address.country || this.address.countryCode;
        this._addressService.getSpatialInfo(postalCode, countryCode)
            .subscribe(function (response) {
            if (response && response.validations.length > 0) {
                if (response.validations[0].message && response.validations[0].name === AddressError.API_REQUEST_DAILY_LIMIT_EXCEED) {
                    var message = response.validations[0].message;
                    var limit = message.replace(/[^0-9]/g, '');
                    var dailyLimitExceedMessage = _this._translateService.get('common.' + 'The Daily Limit of ||requestLimit|| is exceeded and address verification will not function')['value'];
                    dailyLimitExceedMessage = _this._translateKey.transform(dailyLimitExceedMessage, { requestLimit: limit });
                    _this._commonService.setNotification('', dailyLimitExceedMessage, NotificationType.ERROR, 0, true, 80);
                }
            }
            if (response) {
                if (_this.address) {
                    _this.address.latitude = response.latitude;
                    _this.address.longitude = response.longitude;
                    _this.address = _this.prepareNewAddress(_this.address);
                    if (response.success) {
                        _this.address.addressVerified = true;
                    }
                }
                _this.addressSubmit.emit(_this.address);
            }
        });
    };
    // /**
    //  * get selected address
    //  * @returns void
    //  */
    AddressNewComponent.prototype.rebindAddressInfo = function (address) {
        var _this = this;
        this.address = __assign({}, this.address, address);
        this.mapNameAndPhoneFields();
        this.displayAddressBlock = false;
        if (this.address) {
            this.skipAddressVerification = true;
            this.mapSearchAddress(address);
        }
        this.searchAddressOptions = [];
        setTimeout(function () {
            _this.jsonFormObject =
                _this.getParsedSchemaFormJson(_this.originalJsonFormObject);
            _this.maskZipCode();
            _this.jsonFormObject.data = _this.address;
            _this.displayAddressBlock = true;
            _this.changeInputValue(address);
            _this.disableAddressFields(true);
            _this.liveFormData = _this.address;
            if (_this.isInputChangeRequired) {
                _this.addressSubmitOnInputChange.emit(_this.prepareNewAddress(_this.liveFormData));
            }
            if (!_this.isFromFboProfile) {
                _this.addressSubmit.emit(_this.prepareAddressObject(_this.address));
            }
            //this.addressSubmit.emit(this.address);
        }, 0);
    };
    AddressNewComponent.prototype.mapNameAndPhoneFields = function () {
        if (this.liveFormData && this.address) {
            this.address.firstName = this.liveFormData.firstName;
            this.address.middleName = this.liveFormData.middleName;
            this.address.lastName = this.liveFormData.lastName;
            this.address.phone = this.liveFormData.phoneNumber;
            this.address.phoneType = this.liveFormData.phoneType;
            this.address.email = this.liveFormData.email ? this.liveFormData.email : null;
        }
    };
    AddressNewComponent.prototype.mapSearchAddress = function (address) {
        if (this.address.city) {
            var city_1 = this.address.city;
            if (this.participatingCountries && this.participatingCountries.length > 0) {
                var participatingCountry = this.participatingCountries
                    .find(function (x) { return x.name.toLowerCase() === city_1.toLowerCase(); });
                if (participatingCountry) {
                    address.country = participatingCountry.isocodeThree;
                    address.countryId = participatingCountry.countryId;
                }
            }
            else {
                address.country = this.isoCountryCode;
            }
        }
        if (!this.address.phoneType) {
            this.address.phoneType = ContactTypeValue.MOBILE;
        }
        address = this.getStateByStateName(address);
        if (address.stateCode) {
            this.address.stateCode = address.stateCode;
            this.address.state = address.state;
        }
        if (address.country) {
            var country = this.countries.find(function (x) { return x.isocodeThree.toLowerCase()
                === address.country.toLowerCase(); });
            if (country) {
                this.address.country = country.countryId ? String(country.countryId) : '';
                this.address.countryId = country.countryId;
                this.address.countryCode = country.isocodeThree;
                this.address.countryCodeTwo = country.isocodeTwo;
                this.getStatesByCountry(country.countryId);
            }
        }
        this.address.zip = this.address.postalCode;
        if (this.checkoutConfig.verifyMailingWithButton) {
            this.address.addressVerified = false;
        }
        else {
            this.address.addressVerified = address.validAddress;
        }
    };
    /**
     * get search address options info
     * @returns void
     */
    AddressNewComponent.prototype.getSearchAddressOptionsInfo = function (searchAddressOptions) {
        this.searchAddressOptions = searchAddressOptions;
    };
    /**
     * getMaskedZipCode()
     * @param zipCode
     */
    AddressNewComponent.prototype.getMaskedZipCode = function (zipCode) {
        if (this.jsonFormObject && this.jsonFormObject.schema.properties && zipCode) {
            if (this.jsonFormObject.schema.properties.zip
                && this.jsonFormObject.schema.properties.zip.maskFormat && zipCode) {
                zipCode = this._maskPipe.transform(zipCode, this.jsonFormObject.schema.properties.zip.maskFormat);
            }
        }
        return zipCode;
    };
    /**
    * To verify address when we enter address manually for GBR
    * @returns void
    */
    AddressNewComponent.prototype.verifyAddressByDisplayName = function (addressRequestObj) {
        var _this = this;
        addressRequestObj.zip = addressRequestObj.zip.toUpperCase();
        addressRequestObj.postalCode = addressRequestObj.zip.toUpperCase();
        var country = this.getSelectedCountry();
        var displayName = this.prepareDisplayNameByAddress();
        this._addressService.getSearchAddress(country, '', displayName).subscribe(function (verifyAddressResponse) {
            if (verifyAddressResponse && verifyAddressResponse.validations.length > 0) {
                if (verifyAddressResponse.validations[0].message && verifyAddressResponse.validations[0].name === AddressError.API_REQUEST_DAILY_LIMIT_EXCEED) {
                    var message = verifyAddressResponse.validations[0].message;
                    var limit = message.replace(/[^0-9]/g, '');
                    var dailyLimitExceedMessage = _this._translateService.get('common.' + 'The Daily Limit of ||requestLimit|| is exceeded and address verification will not function')['value'];
                    dailyLimitExceedMessage = _this._translateKey.transform(dailyLimitExceedMessage, { requestLimit: limit });
                    _this._commonService.setNotification('', dailyLimitExceedMessage, NotificationType.ERROR, 0, true, 80);
                }
            }
            if (verifyAddressResponse) {
                if (verifyAddressResponse.address) {
                    if (verifyAddressResponse.address && (verifyAddressResponse.address.postalCode || verifyAddressResponse.address.zip)) {
                        var zipCode = _this.getMaskedZipCode(verifyAddressResponse.address.postalCode
                            || verifyAddressResponse.address.zip);
                        verifyAddressResponse.address.zip = zipCode;
                        verifyAddressResponse.address.postalCode = zipCode;
                    }
                    var sameAsSuggestedAddress = _this.compareSuggestedVsEntered(verifyAddressResponse.address);
                    if (sameAsSuggestedAddress) {
                        _this.navigateByEnteredAddress();
                    }
                    else {
                        _this.originalAddress = addressRequestObj;
                        _this.originalAddress =
                            _this.transformAddressZipCode(_this.originalAddress);
                        _this.addressVerificationForm = false;
                        _this.suggestedAddress = verifyAddressResponse.address;
                        _this.suggestedAddress.zip = verifyAddressResponse.address.zip
                            || verifyAddressResponse.address.postalCode;
                        _this.suggestedAddress.phone = _this.originalAddress.phone
                            ? _this.originalAddress.phone : null;
                        _this.suggestedAddress.email = _this.originalAddress.email
                            ? _this.originalAddress.email : null;
                        _this.getSchemaFormButton(false);
                        _this.loadDesktopOrMobileAddressVerification(true);
                    }
                }
                else {
                    _this.navigateByEnteredAddress();
                }
            }
        });
    };
    /**
       * to get selected country details coutry
       */
    AddressNewComponent.prototype.getSelectedCountry = function () {
        var _this = this;
        if (this.address && this.address.country) {
            // const countryId = Number(this.address.country);
            var country = this.countries.find(function (item) { return item.isocodeThree === _this.isoCountryCode; });
            if (!country) {
                country = this.countries.find(function (x) { return x.isocodeThree.toLowerCase()
                    === _this.countryCode.toLowerCase(); });
            }
            return country;
        }
    };
    /**
    * to prepare display name by address
    */
    AddressNewComponent.prototype.prepareDisplayNameByAddress = function () {
        var displayName = '';
        displayName = this.address.addressLine1 ? displayName
            + this.address.addressLine1 + ',' : displayName;
        displayName = this.address.addressLine2 ? displayName
            + this.address.addressLine2 + ',' : displayName;
        displayName = this.address.addressLine3 ? displayName
            + this.address.addressLine3 + ',' : displayName;
        displayName = this.address.city ? displayName
            + this.address.city + ' ' : displayName;
        displayName = this.address.zip ? displayName
            + this.address.zip : displayName;
        return displayName;
    };
    /**
     * compare suggested address vs enetered address manually
     */
    AddressNewComponent.prototype.compareSuggestedVsEntered = function (address) {
        var suggestedAddress = false;
        if (this.originalAddress && address) {
            if ((this.originalAddress.addressLine1 === address.addressLine1)
                && (this.originalAddress.addressLine2 === address.addressLine2
                    || (!this.originalAddress.addressLine2 && !address.addressLine2))
                && (this.originalAddress.addressLine3 === address.addressLine3
                    || (!this.originalAddress.addressLine3 && !address.addressLine3))
                && this.originalAddress.city === address.city
                && this.originalAddress.zip === address.postalCode
                && this.originalAddress.country.toLowerCase() === address.country.toLowerCase()) {
                suggestedAddress = true;
            }
        }
        if (!address.addressLine1 || !address.city) {
            suggestedAddress = true;
        }
        return suggestedAddress;
    };
    /**
     * to navigate to next based on entered address
     */
    AddressNewComponent.prototype.navigateByEnteredAddress = function () {
        this.suggestedAddress = this.originalAddress;
        this.suggestedAddress.zip = this.originalAddress.postalCode
            || this.originalAddress.zip;
        this.suggestedAddress.phone = this.originalAddress.phone
            ? this.originalAddress.phone : null;
        this.suggestedAddress.email = this.originalAddress.email
            ? this.originalAddress.email : null;
        this.selectedAddressType = AddressOptions.SUGGESTEDADDRESS;
        this.selectAddress(true);
    };
    /**
    *Suffixes the Zipcode required for tax calculation
    *
    * @param {Address} address
    * @returns {Address}
    * @memberof AddressNewComponent
    */
    AddressNewComponent.prototype.transformAddressZipCode = function (address) {
        if (address && address.countryId === CountrySuffixZipCodes.USACountrySuffixZipCode.countryId) {
            address.zip = (address.zip && address.zip.length === CountrySuffixZipCodes.USACountrySuffixZipCode.zipCodeLength)
                ? (address.zip + '-' + CountrySuffixZipCodes.USACountrySuffixZipCode.defaultSuffixZipCode) : address.zip;
            address.postalCode = (address.postalCode && address.postalCode.length ===
                CountrySuffixZipCodes.USACountrySuffixZipCode.zipCodeLength) ? (address.postalCode + '-' +
                CountrySuffixZipCodes.USACountrySuffixZipCode.defaultSuffixZipCode) : address.postalCode;
        }
        return address;
    };
    /**
     * @description get states by country
     * @memberof AddressNewComponent
     */
    AddressNewComponent.prototype.getAllStatesByCountry = function () {
        var _this = this;
        if (this.checkoutConfig && this.checkoutConfig.displayCityBasedOnState && this.isShippingAddressSchemaform) {
            this.countryId = this._cacheService.get(CacheKey.COUNTRY_ID);
            this._customerService.getStatesByCountryId(this.countryId).subscribe(function (res) {
                _this.states = res;
                _this._cacheService.set(CacheKey.StatesByCountryId + '_' + _this.countryId, res);
            });
        }
        else {
            this._customerService.getStatesByCountryId(this.countryId).subscribe(function (res) {
                _this.states = res;
                _this._cacheService.set(CacheKey.StatesByCountryId + '_' + _this.countryId, res);
            });
        }
    };
    /**
     * @description to get the country specific schema json file
     * @returns void
     */
    AddressNewComponent.prototype.getJsonSchema = function (address, isEdit) {
        var _this = this;
        this._addressService.getJsonFormSchema(this.schemaUrl)
            .subscribe(function (response) {
            _this.jsonFormObject = _this.getParsedSchemaFormJson(response);
            _this.originalJsonFormObject = response;
            _this.address = address || _this.preloadAddress;
            if (_this.address) {
                if (_this.address && _this.address.countryId) {
                    _this.address.country = String(_this.address.countryId);
                }
                _this.address.zip = _this.address.zip || _this.address.postalCode;
                _this.address.phoneNumber = _this.address.phoneNumber ? _this.validatePhoneNumber(_this.address.phoneNumber) : _this.address.phone ? _this.validatePhoneNumber(_this.address.phone) : '';
                _this.jsonFormObject.data = _this.mapAddressToSchemaFields(_this.address);
                if (_this.address.firstName && _this.address.lastName && _this.address.addressLine1
                    && _this.address.city && _this.address.stateId
                    && !isEdit && (_this.address.addressVerified || _this.address.validAddress) && !_this.isEnableVerifyButton) {
                    _this.jsonFormObject = _this.disableVerifyButton();
                }
                if (!_this.jsonFormObject.data
                    || (_this.jsonFormObject.data
                        && (!_this.jsonFormObject.data.state))) {
                    _this.jsonFormObject.data.state = '';
                }
                _this.showAddressVerification = isEdit ? isEdit : false;
                _this.setContactType(_this.address);
            }
            if (!_this.jsonFormObject.data
                || (_this.jsonFormObject.data
                    && (!_this.jsonFormObject.data.state))) {
                _this.jsonFormObject.data.state = '';
            }
            _this.setContactType();
            if (isEdit) {
                _this.getSchemaFormButton(isEdit);
            }
            _this.findErrorElement();
            if (_this.checkoutConfig.displaySearchAddressSection) {
                _this.disableAddressFields(true);
            }
        }, function (error) {
            if (_this.pollCount < _this.maxpollCount) {
                if (_this.countries) {
                    _this.associateSchemaFormCountry();
                }
                else {
                    var allCountries = JSON.parse(localStorage.getItem("appadmin.Countries"));
                    if (allCountries && allCountries.length > 0) {
                        _this.countries = allCountries;
                        _this.associateSchemaFormCountry();
                    }
                }
                if (_this.liveFormData && _this.liveFormData.state) {
                    _this.liveFormData.state = '';
                }
                if (_this.liveFormData) {
                    _this.liveFormData.countryId = _this.countryId;
                }
                _this.getJsonSchema(_this.liveFormData);
            }
            _this.pollCount = _this.pollCount + 1;
        });
    };
    AddressNewComponent.prototype.associateSchemaFormCountry = function () {
        var _this = this;
        if (this.countries) {
            var country = this.countries.find(function (x) { return x.countryId === _this.countryId; });
            if (country && country.associatedCountryCodeThree) {
                this.schemaUrl = country.associatedCountryCodeThree.toLowerCase() + '-mailing-schema-form.json?templateVersion=' + environment.templateVersion;
            }
            else {
                this.schemaUrl = 'gbl-mailing-schema-form.json?templateVersion=' + environment.templateVersion;
            }
        }
    };
    /**
    * to get all states by country
    */
    AddressNewComponent.prototype.getStatesByCountry = function (countryId) {
        var _this = this;
        if (!this.countries) {
            return;
        }
        var selectedCountry = this.countries
            .find(function (x) { return x.countryId === countryId; });
        if (selectedCountry) {
            this.isoCountryCode = selectedCountry.isocodeThree.toLowerCase();
            this.countryId = selectedCountry.countryId;
            if (this.countryId) {
                this._customerService.getStatesByCountryId(countryId).subscribe(function (res) {
                    _this.states = res;
                });
            }
        }
    };
    /**
     * get parsed json form object
     * @param  {any} jsonText
     * @returns any
     */
    AddressNewComponent.prototype.getParsedSchemaFormJson = function (jsonText) {
        var newFormObject = null;
        try {
            // Parse entered content as JSON
            newFormObject = JSON.parse(jsonText);
        }
        catch (jsonError) {
            try {
                // If entered content is not valid JSON,
                // parse as JavaScript instead to include functions
                newFormObject = null;
                /* tslint:disable */
                eval('newFormObject = ' + jsonText);
                /* tslint:enable */
            }
            catch (javascriptError) {
                return;
            }
        }
        newFormObject = this.getShiipingEmailFieldOptions(newFormObject);
        if (newFormObject) {
            this.changeCountryStateOptionGetUrl(newFormObject);
        }
        return newFormObject;
    };
    AddressNewComponent.prototype.changeCountryStateOptionGetUrl = function (jsonObject) {
        if (this.countryId && jsonObject.schema && jsonObject.schema.properties[SchemaProperty.STATE] && jsonObject.schema.properties[SchemaProperty.STATE].optionGetUrl) {
            jsonObject.schema.properties[SchemaProperty.STATE].optionGetUrl = "/admin/V1/states?countryID=" + this.countryId;
        }
    };
    AddressNewComponent.prototype.getShiipingEmailFieldOptions = function (jsonObject) {
        var _this = this;
        if (this.isShippingAddressSchemaform && this.storeConfig) {
            var jsonSchemaKeys = Object.keys(jsonObject.schema.properties);
            jsonSchemaKeys.forEach(function (obj) {
                if (obj.toLowerCase() === SchemaProperty.EMAIL.toLowerCase() && _this.storeConfig.enableShippingEmailRequired) {
                    if (!jsonObject.schema.required.includes('email')) {
                        jsonObject.schema.required.push(obj);
                        if (!jsonObject.schema.properties[obj].placeholder.endsWith('*')) {
                            jsonObject.schema.properties[obj].placeholder = jsonObject.schema.properties[obj].placeholder + '*';
                        }
                    }
                }
                else if (obj.toLowerCase() === SchemaProperty.EMAIL.toLowerCase() && !_this.storeConfig.enableShippingEmailRequired) {
                    var emailIndex = jsonObject.schema.required.indexOf(obj);
                    if (emailIndex > -1) {
                        jsonObject.schema.required.splice(emailIndex, 1);
                        if (jsonObject.schema.properties[obj].placeholder.endsWith('*')) {
                            jsonObject.schema.properties[obj].placeholder = jsonObject.schema.properties[obj].placeholder.slice(0, -1);
                        }
                    }
                }
            });
            return this.getTranslatedSchemaData(jsonObject);
        }
        else {
            return this.getTranslatedSchemaData(jsonObject);
        }
    };
    /** Schema Form Translation
    * @param  {any} jsonObject
    */
    AddressNewComponent.prototype.getTranslatedSchemaData = function (jsonObject) {
        var _this = this;
        // adding required validation
        if (jsonObject && jsonObject.schema && jsonObject.schema.required) {
            if (this.isChangeRegisteredAddress) {
                jsonObject.schema.required.push(SchemaProperty.COUNTRY);
            }
        }
        // Translate Schema form fields.
        if (jsonObject && jsonObject.schema && jsonObject.schema.properties) {
            var jsonSchemaKeys = Object.keys(jsonObject.schema.properties);
            if (jsonSchemaKeys) {
                jsonSchemaKeys.forEach(function (obj) {
                    // Translate Schema Form fields.
                    var translatedText = jsonObject.schema.properties[obj].placeholder || jsonObject.schema.properties[obj].selectText;
                    if (translatedText.endsWith('*')) {
                        translatedText = translatedText.slice(0, -1);
                    }
                    var translatedValue = _this._translateService.get('schemaform.' + translatedText)['value'];
                    translatedValue = translatedValue ? translatedValue : translatedText;
                    if (jsonObject.schema.required) {
                        if (jsonObject.schema.required.indexOf(obj) > -1) {
                            translatedValue += '*';
                        }
                    }
                    translatedValue = translatedValue ? translatedValue : translatedText;
                    if (jsonObject.schema.properties[obj].placeholder) {
                        jsonObject.schema.properties[obj].placeholder = translatedValue;
                    }
                    else if (jsonObject.schema.properties[obj].selectText) {
                        jsonObject.schema.properties[obj].selectText = translatedValue;
                    }
                    // Unique Validation Message Translation
                    if (jsonObject.schema.properties[obj].uniqueValidationMessage) {
                        var errorTranslatedText = jsonObject.schema.properties[obj].uniqueValidationMessage;
                        var errorTranslatedValue = _this._translateService.get('schemaform.' + errorTranslatedText)['value'];
                        jsonObject.schema.properties[obj].uniqueValidationMessage = errorTranslatedValue ?
                            errorTranslatedValue : errorTranslatedText;
                    }
                    // Translate Validation messages.
                    if (jsonObject.schema.properties[obj].validationMessages) {
                        var validationMessagesKeys = Object.keys(jsonObject.schema.properties[obj].validationMessages);
                        validationMessagesKeys.forEach(function (validationObj) {
                            if (validationObj) {
                                var errorTranslatedText = jsonObject.schema.properties[obj].validationMessages[validationObj];
                                if (errorTranslatedText) {
                                    var errorTranslatedValue = _this._translateService.get('schemaform.' + errorTranslatedText)['value'];
                                    errorTranslatedValue = errorTranslatedValue ? errorTranslatedValue : errorTranslatedText;
                                    jsonObject.schema.properties[obj].validationMessages[validationObj] = errorTranslatedValue ?
                                        errorTranslatedValue : errorTranslatedText;
                                }
                            }
                        });
                    }
                    if (_this.isChangeRegisteredAddress) {
                        _this.changeOptionGetUrl(jsonObject, obj);
                    }
                });
            }
        }
        // Translate Schema form Button Text.
        if (jsonObject && (jsonObject.form || jsonObject.layout)) {
            var jsonObjectForm = jsonObject.form || jsonObject.layout;
            for (var i = 0; i < jsonObjectForm.length; i++) {
                jsonObjectForm[i].items = this.searchButtonTitle(jsonObjectForm[i].items);
            }
        }
        return jsonObject;
    };
    /**
     * @description to set option get url
     * @date 2020-10-07
     * @param {*} jsonObject
     * @param {string} obj
     * @memberof AddressNewComponent
     */
    AddressNewComponent.prototype.changeOptionGetUrl = function (jsonObject, obj) {
        if (obj === SchemaProperty.STATE) {
            if (jsonObject.schema.properties[obj].optionGetUrl) {
                var optionGetUrl = jsonObject.schema.properties[obj].optionGetUrl
                    .replace(new RegExp('{countryId}', 'g'), this.countryId);
                jsonObject.schema.properties[obj].optionGetUrl = optionGetUrl;
            }
        }
        if (obj === SchemaProperty.COUNTRY) {
            if (jsonObject.schema.properties[obj].countryApiUrl) {
                jsonObject.schema.properties[obj].optionGetUrl = jsonObject.schema.properties[obj].countryApiUrl;
            }
            if (jsonObject.schema.properties[obj].disabled) {
                jsonObject.schema.properties[obj].disabled = false;
            }
        }
    };
    /** Search Button text
     * @param  {any} items
     */
    AddressNewComponent.prototype.searchButtonTitle = function (items) {
        var _this = this;
        items.forEach(function (element) {
            if (element.title) {
                var translatedText = element.title;
                var translatedValue = _this._translateService.get('schemaform.' + translatedText)['value'];
                translatedValue = translatedValue ? translatedValue : translatedText;
                element.title = translatedValue;
            }
            // to disable Country field
            if (element.key && element.key === SchemaProperty.COUNTRY && _this.isChangeRegisteredAddress) {
                element.disabled = false;
            }
            if (element.items instanceof Array) {
                var item = element.items;
                _this.searchButtonTitle(item);
            }
        });
        return items;
    };
    /**
     * @returns void
     */
    AddressNewComponent.prototype.findErrorElement = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.jsonFormObject && _this.jsonFormObject.data) {
                _this.addressInputChanged.emit(false);
            }
            _this.validationMessageInitialHide = false;
            if (document.getElementsByClassName('help-block').length > 0) {
                _this.hideErrorElement(true);
            }
        }, 500);
    };
    /**
     * @param  {boolean} hide
     * @returns void
     */
    AddressNewComponent.prototype.hideErrorElement = function (hide) {
        var elements = this.elementRef.nativeElement.getElementsByClassName('help-block');
        if (elements) {
            for (var i = 0; i < elements.length; i++) {
                if (hide) {
                    this._renderer.setElementClass(elements[i], 'hide', true);
                    this._renderer.setElementClass(elements[i], 'show', false);
                }
                else {
                    this._renderer.setElementClass(elements[i], 'show', true);
                    this._renderer.setElementClass(elements[i], 'hide', false);
                }
            }
        }
    };
    /**
     * to save address
     * and to emit the onsubmit output emmiter
     * @param  {any} address
     * @returns void
     */
    AddressNewComponent.prototype.saveAddress = function (address) {
        var _this = this;
        if (address) {
            // To reset the address Input change after the user submit
            this.address = this._commonService.trimObjectValues(address);
            if ((!this.addressVerificationForm || this.isAddressFormChanged) && !this.skipAddressVerification) {
                this.showAddressVerification = false;
                this.originalAddress = this.prepareNewAddress(address);
                if (this.checkoutConfig.displaySearchAddressSection) {
                    // this.originalAddress.disableAddressBlock =
                    // checkoutInformation && checkoutInformation.personalInformation
                    //  && checkoutInformation.personalInformation.isAutoPopulate ? true : false;
                    this.verifyAddressByDisplayName(this.originalAddress);
                    this.addressInputChanged.emit(false);
                }
                else {
                    this.getSuggestedAddress(this.originalAddress);
                }
            }
            else {
                this.processEnteredAddress(address);
                setTimeout(function () {
                    _this.addressInputChanged.emit(false);
                }, 100);
            }
        }
        else {
            this.hideErrorElement(false);
        }
    };
    AddressNewComponent.prototype.maskZipCode = function () {
        if (this.jsonFormObject && this.jsonFormObject.schema.properties
            && this.address) {
            var postalCode = this.address.zip || this.address.postalCode;
            if (this.jsonFormObject.schema.properties.zip
                && this.jsonFormObject.schema.properties.zip.maskFormat && postalCode) {
                var zip = this._maskPipe.transform(postalCode, this.jsonFormObject.schema.properties.zip.maskFormat);
                this.address.postalCode = zip;
                this.address.zip = zip;
            }
        }
    };
    /**
     * @description get adderss
     * @param {Address} address
     * @returns {Address}
     * @memberof AddressNewComponent
     */
    AddressNewComponent.prototype.prepareNewAddress = function (address) {
        if (address) {
            var state = void 0;
            if (this.states && this.states.length > 0) {
                address = this.getStateByStateName(address);
                if (address.state) {
                    state = this.states.find(function (x) { return x.stateCode.toUpperCase() === address.state.toUpperCase(); });
                }
                if (!state) {
                    state = this.states[0];
                }
            }
            var country = void 0;
            if (this.countries && this.countries.length > 0) {
                var countryCode_1 = this.getShippingCountryCode();
                if (!address.country && !address.countryId) {
                    address.country = countryCode_1;
                }
                country = this.countries
                    .find(function (x) { return x.countryId === (address.countryId ? address.countryId : Number(address.country)); });
                if (!country && (typeof address.country === 'string')) {
                    country = this.countries
                        .find(function (x) { return x.isocodeThree.toLowerCase() === countryCode_1.toLowerCase(); });
                }
            }
            if (this.checkoutConfig.displaySearchAddressSection && this.skipAddressVerification) {
                address.validAddress = true;
            }
            var mappedAddress = {
                name: address.name,
                firstName: address.firstName,
                lastName: address.lastName,
                middleName: address.middleName,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3,
                addressLine4: address.addressLine4,
                city: address.city,
                state: state ? state.stateCode : '',
                stateId: state ? state.id : 0,
                stateCode: state ? state.stateCode : '',
                zip: address.zip || address.postalCode,
                postalCode: address.zip || address.postalCode,
                countryId: Number(address.country) || this.countryId,
                country: country ? country.isocodeThree : this.isoCountryCode,
                countryCode: country ? country.isocodeThree : this.isoCountryCode,
                addressVerified: address.addressVerified || address.validAddress,
                addressId: address.addressId,
                latitude: address.latitude,
                longitude: address.longitude,
                validAddress: address.validAddress,
                phone: address.phone ? address.phone : address.phoneNumber ? address.phoneNumber : null,
                phoneNumber: address.phone ? address.phone : address.phoneNumber ? address.phoneNumber : null,
                phoneType: address.phoneType,
                isShowStateCode: this.checkoutConfig.showStateCode,
                saveForFutureUse: address.saveForFutureUse,
                disableAddressBlock: address.disableAddressBlock,
                deliveryInstruction: address.deliveryInstruction,
                email: address.email ? address.email : null
            };
            return mappedAddress;
        }
    };
    /**
    * @description to get the suggested address and perform specific actions
    * @returns void
    */
    AddressNewComponent.prototype.getSuggestedAddress = function (addressRequestObj) {
        var _this = this;
        this.responseCodes = [];
        this._addressService.getSuggestedAddress(addressRequestObj)
            .subscribe(function (verifyAddressResponse) {
            if (verifyAddressResponse) {
                _this.addressInputChanged.emit(false);
                _this.errorCodes = null;
                _this.errorCodesLength = null;
                if (verifyAddressResponse.errorCodes && verifyAddressResponse.errorCodes.length > 0) {
                    verifyAddressResponse.errorCodes.forEach(function (code) {
                        verifyAddressResponse.saveForFutureUse = addressRequestObj.saveForFutureUse;
                        var responseCode = {
                            responseCode: code.errorCode,
                            responseDescription: code.validationMessage
                        };
                        _this.responseCodes.push(responseCode);
                    });
                    _this.errorCodes = verifyAddressResponse.errorCodes.filter(function (x) {
                        return x.messageRequired === true && x.propertyName !== 'Note';
                    });
                    _this.errorCodesLength = _this.errorCodes.length;
                    _this.errorCodes.forEach(function (code) {
                        if (code.shortDescription) {
                            var translatedValue = _this._translateService.instant(decodeURIComponent(encodeURIComponent('checkout.' + code.errorCode + '_' + code.shortDescription)));
                            translatedValue = _this._translateKey.transform(translatedValue, false);
                            code.shortDescription = translatedValue;
                        }
                    });
                    _this.errorCodes = _this.errorCodes.filter(function (x) { return x.shortDescription && x.shortDescription.length > 0; });
                }
                if (verifyAddressResponse.errorCodes
                    && verifyAddressResponse.errorCodes.find(function (x) { return x.errorCode && x.errorCode.indexOf(AddressError.AE) > -1; })) {
                    // Handling the Address verification form when modal pop is open.
                    if (_this.isModalOpen && _this.isAddressFormChanged) {
                        _this.isAddressFormChanged = false;
                        _this.processEnteredAddress(addressRequestObj);
                        setTimeout(function () {
                            _this.addressInputChanged.emit(false);
                        }, 100);
                    }
                    else {
                        _this.addressVerificationForm = true;
                        _this.isAddressFormChanged = false;
                        _this.populateSuggestedAddress(verifyAddressResponse);
                        _this.loadDesktopOrMobileAddressVerification(true);
                    }
                }
                else if (verifyAddressResponse.sameAsSuggestedAddress) {
                    _this.suggestedAddress = verifyAddressResponse;
                    _this.suggestedAddress.zip = verifyAddressResponse.postalCode;
                    _this.suggestedAddress.phone = _this.originalAddress.phone
                        ? _this.originalAddress.phone : null;
                    _this.suggestedAddress.email = _this.originalAddress.email
                        ? _this.originalAddress.email : null;
                    if (_this.originalAddress.deliveryInstruction) {
                        _this.suggestedAddress.deliveryInstruction = _this.originalAddress.deliveryInstruction;
                    }
                    _this.selectedAddressType = AddressOptions.SUGGESTEDADDRESS;
                    _this.selectAddress();
                }
                else if (_this.participatingCountry) {
                    _this.suggestedAddress = addressRequestObj;
                    _this.selectedAddressType = AddressOptions.ORIGINALADDRESS;
                    _this.selectAddress();
                }
                else {
                    if (verifyAddressResponse && !verifyAddressResponse.city && !verifyAddressResponse.state) {
                        _this.suggestedAddress = _this.originalAddress;
                        _this.selectedAddressType = AddressOptions.ORIGINALADDRESS;
                        _this.selectAddress();
                    }
                    else {
                        _this.originalAddress = addressRequestObj;
                        _this.addressVerificationForm = false;
                        _this.suggestedAddress = verifyAddressResponse;
                        _this.suggestedAddress.zip = verifyAddressResponse.postalCode;
                        _this.suggestedAddress.phone = _this.originalAddress.phone
                            ? _this.originalAddress.phone : null;
                        _this.suggestedAddress.email = _this.originalAddress.email
                            ? _this.originalAddress.email : null;
                        if (_this.originalAddress.deliveryInstruction) {
                            _this.suggestedAddress.deliveryInstruction = _this.originalAddress.deliveryInstruction;
                        }
                        _this.getSchemaFormButton(false);
                        _this.loadDesktopOrMobileAddressVerification(true);
                    }
                }
            }
        }, function (error) {
            if (error.validations.find(function (validation) { return validation.name && validation.name.indexOf(AddressError.API_REQUEST_DAILY_LIMIT_EXCEED) === 0; })) {
                var message = error.validations[0].message;
                var limit = message.replace(/[^0-9]/g, '');
                var dailyLimitExceedMessage = _this._translateService.get('common.' + 'The Daily Limit of ||requestLimit|| is exceeded and address verification will not function')['value'];
                dailyLimitExceedMessage = _this._translateKey.transform(dailyLimitExceedMessage, { requestLimit: limit });
                _this._commonService.setNotification('', dailyLimitExceedMessage, NotificationType.ERROR, 0, true, 80);
                _this.addressSubmit.emit(_this.originalAddress);
            }
            if (error.validations.find(function (validation) {
                return validation.message && validation.message.indexOf('Provider Information is not available for Country Code') === 0;
            })) {
                _this.addressSubmit.emit(_this.originalAddress);
            }
        });
    };
    /**
     * @description method to populate suggested address
     * @param {Address} suggestedAddress
     * @memberof AddressNewComponent
     */
    AddressNewComponent.prototype.populateSuggestedAddress = function (suggestedAddress) {
        if (suggestedAddress) {
            this.addressVerificationForm = false;
            if (!this.chRef['destroyed']) {
                this.chRef.detectChanges();
            }
            if (suggestedAddress.errorCodes && suggestedAddress.errorCodes.length > 0) {
                this.jsonFormObject = this.getCustomErrorMessages(suggestedAddress.errorCodes);
            }
            this.jsonFormObject = this.getSchemaFormButton(true);
            this.jsonFormObject.data =
                this.mapAddressToSchemaFields(this.originalAddress);
        }
        else {
            this.jsonFormObject.data = suggestedAddress;
        }
        this.addressVerificationForm = true;
        this.showAddressVerification = false;
        this.findErrorElement();
    };
    /**
     * once we click on verify button, show the 3 bttons and note block
     * and hide the verify button
     * @returns any
     */
    AddressNewComponent.prototype.getSchemaFormButton = function (show) {
        if (this.jsonFormObject && this.jsonFormObject.form) {
            var form = this.jsonFormObject.form.filter(function (x) { return x.type === 'div'; });
            if (form && form.length) {
                var items = form[0].items;
                if (items && items.length) {
                    items.forEach(function (x) {
                        if (x && x.items.length > 0) {
                            x.items.forEach(function (y) {
                                if (y.eventId === 'UseOriginalAddress') {
                                    if (show) {
                                        y.fieldHtmlClass = 'show';
                                    }
                                    else {
                                        y.fieldHtmlClass = 'hide';
                                    }
                                }
                                if (y.eventId === 'VerifyAddress') {
                                    if (show) {
                                        y.fieldHtmlClass = 'show verify-address';
                                    }
                                    else {
                                        y.fieldHtmlClass = 'hide verify-address';
                                    }
                                }
                            });
                        }
                    });
                }
            }
        }
        else if (this.jsonFormObject && this.jsonFormObject.layout) {
            var layout = this.jsonFormObject.layout.find(function (x) { return x.container === 'button'; });
            if (layout && layout.items) {
                layout.items.forEach(function (y) {
                    if (y.eventId === 'UseOriginalAddress') {
                        if (show) {
                            y.fieldHtmlClass = 'show';
                        }
                        else {
                            y.fieldHtmlClass = 'hide';
                        }
                    }
                    if (y.eventId === 'VerifyAddress') {
                        if (show) {
                            y.fieldHtmlClass = 'show verify-address';
                        }
                        else {
                            y.fieldHtmlClass = 'hide verify-address';
                        }
                    }
                });
            }
        }
        return this.jsonFormObject;
    };
    /**
     * @description disable verify button after the address selection
     * @date 2018-11-28
     * @returns
     * @memberof AddressNewComponent
     */
    AddressNewComponent.prototype.disableVerifyButton = function () {
        if (this.jsonFormObject && this.jsonFormObject.form) {
            var formItems = this.jsonFormObject.form.filter(function (x) { return x.type === 'div'; });
            if (formItems && formItems.length) {
                formItems.forEach(function (x) {
                    if (x && x.items && x.items.length > 0) {
                        x.items.forEach(function (y) {
                            if (y && y.items && y.items.length) {
                                y.items.forEach(function (z) {
                                    if (z.eventId === 'VerifyAddress') {
                                        z.disabled = true;
                                    }
                                });
                            }
                        });
                    }
                });
            }
        }
        else if (this.jsonFormObject && this.jsonFormObject.layout) {
            var layout = this.jsonFormObject.layout.find(function (x) { return x.container === 'button'; });
            if (layout && layout.items) {
                layout.items.forEach(function (z) {
                    if (z.eventId === 'VerifyAddress') {
                        z.disabled = true;
                    }
                });
            }
        }
        return this.jsonFormObject;
    };
    /**
     * @description enable verify button after the address selection
     * @returns
     * @memberof AddressNewComponent
     */
    AddressNewComponent.prototype.enableVerifyButton = function () {
        if (this.jsonFormObject && this.jsonFormObject.form) {
            var formItems = this.jsonFormObject.form.filter(function (x) { return x.type === 'div'; });
            if (formItems && formItems.length) {
                formItems.forEach(function (x) {
                    if (x && x.items && x.items.length > 0) {
                        x.items.forEach(function (y) {
                            if (y && y.items && y.items.length) {
                                y.items.forEach(function (z) {
                                    if (z.eventId === 'VerifyAddress') {
                                        z.disabled = false;
                                    }
                                });
                            }
                        });
                    }
                });
            }
        }
        else if (this.jsonFormObject && this.jsonFormObject.layout) {
            var layout = this.jsonFormObject.layout.find(function (x) { return x.container === 'button'; });
            if (layout && layout.items) {
                layout.items.forEach(function (z) {
                    if (z.eventId === 'VerifyAddress') {
                        z.disabled = false;
                    }
                });
            }
        }
        return this.jsonFormObject;
    };
    /**
     * to get error messages
     * @param  {any} errorCode
     */
    AddressNewComponent.prototype.getCustomErrorMessages = function (errorCode) {
        var _this = this;
        if (this.jsonFormObject && (this.jsonFormObject.form && this.jsonFormObject.layout)) {
            Object.keys(this.jsonFormObject.schema.properties).forEach(function (x, y) {
                var errorProperty = errorCode.filter(function (z) { return z.propertyName.toUpperCase() === x.toUpperCase(); });
                var schemaProperty = _this.jsonFormObject.schema.properties[x];
                if (errorProperty.length > 0) {
                    schemaProperty.customErrorMessage = '';
                    errorProperty.forEach(function (error) {
                        if (error.messageType === 'AddressCorrected') {
                            schemaProperty.customErrorMessage = '';
                            schemaProperty.htmlClass = 'color-green';
                        }
                        // else if (error.messageType === 'ErrorMessage') {
                        //     let translatedValue = this._translateService.get('schemaform.' + error.validationMessage)['value'];
                        //     translatedValue = translatedValue ? translatedValue : error.validationMessage;
                        //     schemaProperty.customErrorMessage = schemaProperty.customErrorMessage !== ''
                        //         && schemaProperty.customErrorMessage !== undefined ?
                        //         '<div>' + schemaProperty.customErrorMessage + '</div><div>' + translatedValue + '</div>'
                        //         : translatedValue;
                        //     schemaProperty.htmlClass = 'color-yellow';
                        // }
                    });
                }
                else {
                    schemaProperty.customErrorMessage = '';
                }
            });
        }
        return this.jsonFormObject;
    };
    /**
    * @param  {any} address
    * @returns any
    */
    AddressNewComponent.prototype.mapAddressToSchemaFields = function (address) {
        if (address) {
            this.setContactType(true);
            var mapSchemaFields = {
                firstName: address.firstName,
                middleName: address.middleName,
                lastName: address.lastName,
                name: address.name || address.shipToName,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3,
                addressLine4: address.addressLine4,
                city: address.city,
                state: address.stateCode || address.state,
                zip: address.zip || address.postalCode || address.zipCode,
                country: String(address.countryId),
                phone: address.phoneNumber ? address.phoneNumber : address.phone ? address.phone : null,
                phoneType: address.phoneType ? address.phoneType : this.checkoutConfig.removeMobileField ? ContactTypeValue.PHONE : ContactTypeValue.MOBILE,
                saveForFutureUse: address.saveForFutureUse || address.isSavedAddress,
                isSavedAddress: address.isSavedAddress,
                disableAddressBlock: address.disableAddressBlock,
                deliveryInstruction: address.deliveryInstruction,
                email: address.email ? address.email : null
            };
            return mapSchemaFields;
        }
    };
    /**
     * Store the selected address type
     * @param selectedAddressType
     */
    AddressNewComponent.prototype.setAddressType = function (selectedAddressType) {
        this.selectedAddressType = selectedAddressType;
    };
    /**
     * select Address
     */
    AddressNewComponent.prototype.selectAddress = function (isPreventReload) {
        var _this = this;
        if (this.selectedAddressType === AddressOptions.ORIGINALADDRESS) {
            this.getJsonSchema(this.originalAddress);
            this.emitEnteredAddress(this.originalAddress);
        }
        else if (this.selectedAddressType === AddressOptions.SUGGESTEDADDRESS) {
            this.suggestedAddress.name = this.originalAddress.name;
            this.suggestedAddress.firstName = this.originalAddress.firstName;
            this.suggestedAddress.middleName = this.originalAddress.middleName;
            this.suggestedAddress.lastName = this.originalAddress.lastName;
            this.suggestedAddress.phoneType = this.originalAddress.phoneType;
            if (this.originalAddress && this.originalAddress.country === this.suggestedAddress.country
                && this.originalAddress.countryId) {
                this.suggestedAddress.countryId = this.originalAddress.countryId;
            }
            if (this.states && this.states.length > 0 && this.suggestedAddress && !this.checkoutConfig.showStateCode) {
                this.suggestedAddress = this.getStateByStateName(this.suggestedAddress);
                var state = void 0;
                if (this.suggestedAddress.state) {
                    state = this.states.find(function (x) { return x.stateCode.toUpperCase() === _this.suggestedAddress.state.toUpperCase(); });
                }
                if (!state) {
                    state = this.states[0];
                }
                this.suggestedAddress.state = state ? state.stateCode : this.suggestedAddress.state;
            }
            if (this.checkoutConfig && !this.checkoutConfig.loadParticipatingCountries) {
                this.suggestedAddress.countryId = this.originalAddress.countryId;
            }
            this.getJsonSchema(this.suggestedAddress);
            this.emitEnteredAddress(this.suggestedAddress);
        }
        this.loadDesktopOrMobileAddressVerification(false);
    };
    /**
     * @description this method is used
     * emit entered address from child to parent
     * component
     * @date 2018-07-20
     * @memberof AddressComponent
     */
    AddressNewComponent.prototype.emitEnteredAddress = function (address) {
        this.address = this.prepareNewAddress(address);
        if (this.checkoutConfig.displaySearchAddressSection) {
            this.getSpatialInfo();
        }
        else {
            this.addressSubmit.emit(this.address);
        }
    };
    /**
     * to perform actions on click of each button
     * @param  {any} event
     * @returns void
     */
    AddressNewComponent.prototype.verifyButtonSubmit = function (event) {
        if (event.eventId === 'UseOriginalAddress' && this.liveFormStatus) {
            this.processEnteredAddress(this.liveFormData);
        }
        else if (event.eventId === 'Cancel' && this.isChangeRegisteredAddress) {
            this.cancelChangeAddress.emit(true);
        }
        else {
            this.hideErrorElement(false);
        }
    };
    /**
     * @description this method ued to
     * emit address from child to parent
     * component while
     * @date 2018-07-23
     * @param {Address} address
     * @memberof AddressComponent
     */
    AddressNewComponent.prototype.processEnteredAddress = function (address) {
        this.addressVerificationForm = false;
        this.hideErrorElement(true);
        var existingAddress = this.prepareNewAddress(address);
        this.emitEnteredAddress(existingAddress);
        this.loadDesktopOrMobileAddressVerification(false);
        if (existingAddress && existingAddress.addressVerified) {
            this.jsonFormObject = this.disableVerifyButton();
            if (this.skipAddressVerification && this.checkoutConfig.displaySearchAddressSection) {
                this.disableAddressFields(true);
            }
        }
        this.hideErrorElement(false);
    };
    /**
     * @returns void
     */
    AddressNewComponent.prototype.onHidden = function () {
        this.getSchemaFormButton(false);
    };
    /**
    * re bind form when we click on change address
    * @returns void
    */
    AddressNewComponent.prototype.rebindForm = function () {
        var _this = this;
        this.editSubscription = this._commonService.getEmitter('editAddress')
            .subscribe(function (response) {
            _this.getJsonSchema(response);
            _this.jsonFormObject.data = response;
            if (response && !response.isSavedAddress) {
                if (!_this.chRef['destroyed']) {
                    _this.chRef.detectChanges();
                }
                _this.addressVerificationForm = true;
                _this.loadDesktopOrMobileAddressVerification(true);
            }
        });
    };
    /**
     * @description this method will be used
     * to load address verification based on mobile or desktop devices
     * @date 2018-08-02
     * @private
     * @memberof AddressComponent
     */
    AddressNewComponent.prototype.loadDesktopOrMobileAddressVerification = function (displayVerification) {
        var _this = this;
        this.displayAddressBlock = displayVerification;
        this.addressHidden.emit(this.displayAddressBlock);
        if (displayVerification) {
            if (!this.isModalOpen) {
                this.isModalOpen = true;
                this.addressModal.closeOnOutsideClick = false;
                this.addressModal.closeOnEscape = false;
                this.addressModal.open();
            }
        }
        else {
            this.isModalOpen = false;
            this.jsonFormObject = this.getParsedSchemaFormJson(this.originalJsonFormObject);
            if (this.address && this.address.countryId) {
                this.address.country = String(this.address.countryId);
            }
            this.jsonFormObject.data = this.mapAddressToSchemaFields(this.address);
            if (this.skipAddressVerification && this.checkoutConfig.displaySearchAddressSection) {
                this.disableAddressFields(true);
            }
            this.addressModal.close();
        }
        if (!this.displayAddressBlock) {
            setTimeout(function () {
                _this.displayAddressBlock = true;
                _this.addressHidden.emit(_this.displayAddressBlock);
            }, 100);
        }
    };
    /**
     *Edit the Address
     * @param {Address} originalAddress
     * @memberof AddressComponent
     */
    AddressNewComponent.prototype.editAddress = function (originalAddress) {
        this.addressVerificationForm = true;
        this.getJsonSchema(originalAddress, true);
        this.jsonFormObject.data = originalAddress;
        this.showAddressVerification = true;
    };
    /**
     * @description this method will get status of form
     * @date 2018-10-10
     * @memberof AddressNewComponent
     */
    AddressNewComponent.prototype.liveFormDataIsValid = function (formStatus) {
        this.liveFormStatus = formStatus;
        this.liveFormStatusIsValid.emit(formStatus);
    };
    /**
    * @description this method will mask phone number based on country format
    * @date 2018-11-13
    * @private
    * @memberof AddressComponent
    */
    AddressNewComponent.prototype.validatePhoneNumber = function (phoneNumber) {
        if (phoneNumber) {
            var delimiter = phoneNumber.charAt(0);
            phoneNumber = this.maskPhoneNumber(phoneNumber, this.countryCode);
            // if(delimiter === '+' && this.storeConfig && this.storeConfig.foreverDirectEnabled){
            //   phoneNumber = delimiter + phoneNumber;
            // }
            return phoneNumber;
        }
    };
    AddressNewComponent.prototype.maskPhoneNumber = function (phone, countryCode) {
        var phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(countryCode);
        if (phoneNumberFormat && phone) {
            return this._maskPipe.transform(phone, phoneNumberFormat);
        }
        return phone;
    };
    /**
     * @description
     * @date 2020-05-02
     * @private
     * @memberof AddressNewComponent
     */
    AddressNewComponent.prototype.getCustomSelectOption = function () {
        var _this = this;
        this.customSelectSubscription = this.messageService.getCustomSelect()
            .subscribe(function (countryId) {
            if (countryId) {
                var selectedCountry = _this.countries
                    .find(function (x) { return x.countryId === parseInt(countryId, 10); });
                if (selectedCountry) {
                    _this.isoCountryCode = selectedCountry.isocodeThree.toLowerCase();
                    _this.countryCode = _this.isoCountryCode;
                    _this.countryId = selectedCountry.countryId;
                    if (_this.countryId) {
                        _this.getStatesByCountry(_this.countryId);
                    }
                    if (_this.isChangeRegisteredAddress) {
                        _this.changeSchemaForm(selectedCountry);
                    }
                    if (_this.isShippingAddressSchemaform && _this.checkoutConfig && _this.checkoutConfig.changeSchemaFormOnCountryChange) {
                        _this.changeSchemaOnCountryChange(false, selectedCountry);
                    }
                }
            }
            _this.pollCount = 0;
        });
    };
    /** disable schema address form fields
    * @param  {any} jsonObject
    */
    AddressNewComponent.prototype.disableAddressFields = function (isDisable) {
        var _this = this;
        if (!this.addressVerificationForm && isDisable) {
            setTimeout(function () {
                var schemaClass = '.' + _this.schemaClass;
                var addressElements = document.querySelectorAll(schemaClass + ' .disable_field input,' + schemaClass + ' .disable_field select');
                if (addressElements && _this.checkoutConfig.displaySearchAddressSection) {
                    for (var i = 0; i < addressElements.length; i++) {
                        addressElements[i].disabled = true;
                    }
                }
            }, 500);
        }
    };
    /**
     * @description to get New Schema-Form Based on Country code when We change Country
     * @author Akhil
     * @date 2021-04-08
     * @param {boolean} [onLoad]
     * @param {*} [selectedCountry]
     * @memberof AddressNewComponent
     */
    AddressNewComponent.prototype.changeSchemaOnCountryChange = function (onLoad, selectedCountry) {
        var address = null;
        var countryCode = null;
        if (!onLoad) {
            address = this.liveFormData;
            countryCode = selectedCountry ? selectedCountry.isocodeThree : null;
        }
        else {
            address = this.address || this.preloadAddress;
            countryCode = address ? address.countryCode : null;
        }
        if (address) {
            if (countryCode) {
                if (this.isShippingAddressSchemaform) {
                    this.schemaUrl = countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                        + environment.templateVersion;
                }
            }
        }
        if (!onLoad && this.liveFormData) {
            this.liveFormData.state = "";
            this.liveFormData.countryId = this.countryId;
            this.getJsonSchema(this.liveFormData);
        }
    };
    /**
     * To enable the address fields when click on don't match address link
     * @returns void
     */
    AddressNewComponent.prototype.enableAddressFields = function () {
        var _this = this;
        this.enableAddressFieldSubscription = this.messageService.getEnableAddressFields().subscribe(function (addressInfo) {
            if (addressInfo.isEnableAddressFields) {
                _this.skipAddressVerification = false;
                var elements = document.querySelectorAll('.' + addressInfo.block + ' .disable_field input, .disable_field select');
                if (elements) {
                    for (var i = 0; i < elements.length; i++) {
                        elements[i].disabled = false;
                    }
                }
            }
        });
    };
    /**
     * getStateByStateName()
     * @param address
     */
    AddressNewComponent.prototype.getStateByStateName = function (address) {
        if (this.states && this.states.length > 0
            && this.checkoutConfig.findStateByStateName && address && address.state) {
            var state = this.states.find(function (x) { return x.stateName.toLowerCase() === address.state.toLowerCase(); });
            if (!state) {
                state = this.states.find(function (x) { return x.stateName ? address.state.toLowerCase().indexOf(x.stateName.toLowerCase()) > -1 : null; });
            }
            if (state && state.stateCode) {
                address.state = state.stateCode;
                address.stateCode = state.stateCode;
            }
        }
        return address;
    };
    /**
     * To avoid MemoryLeaks need to unsubscribe.
     */
    AddressNewComponent.prototype.ngOnDestroy = function () {
        this.chRef.detach();
        if (this.editSubscription) {
            this.editSubscription.unsubscribe();
        }
        if (this.submitAddressSubscription) {
            this.submitAddressSubscription.unsubscribe();
        }
        if (this.customSelectSubscription) {
            this.customSelectSubscription.unsubscribe();
        }
        if (this.enableAddressFieldSubscription) {
            this.enableAddressFieldSubscription.unsubscribe();
        }
    };
    /**
     * @description get adderss
     * @param {Address} address
     * @returns {Address}
     * @memberof AddressNewComponent
     */
    AddressNewComponent.prototype.prepareAddressObject = function (address) {
        if (address) {
            var res_1;
            this._customerService.getStatesByCountryId(address.countryId).toPromise().then(function (result) {
                res_1 = result;
            });
            var state = void 0;
            if (res_1) {
                state = res_1[0];
            }
            else {
                if (this.states && this.states.length > 0) {
                    if (address.state) {
                        state = this.states.find(function (x) { return x.stateCode.toUpperCase() === address.state.toUpperCase(); });
                    }
                    if (!state) {
                        state = this.states[0];
                    }
                }
            }
            address.state = address.state ? address.state : (state ? state.stateCode : '');
            address.stateId = state ? state.id : 0;
            address.stateCode = state ? state.stateCode : '';
            return address;
        }
    };
    /**
     * @description to chanage schema form based on selected country
     * @date 2020-10-07
     * @param {*} selectedCountry
     * @memberof AddressNewComponent
     */
    AddressNewComponent.prototype.changeSchemaForm = function (selectedCountry) {
        if (selectedCountry) {
            var country = 'gbl';
            this.loadCheckoutConfig(selectedCountry);
            if (this.checkoutConfig) {
                this.isDisplaySearchAddressSection.emit(this.checkoutConfig.displaySearchAddressSection);
                if (this.checkoutConfig.loadParticipatingCountries) {
                    country = selectedCountry.associatedCountryCodeThree ? selectedCountry.associatedCountryCodeThree : selectedCountry.isocodeThree;
                }
                else {
                    country = selectedCountry.isocodeThree ? selectedCountry.isocodeThree : selectedCountry.associatedCountryCodeThree;
                }
            }
            this.schemaUrl = country.toLowerCase() +
                '-mailing-schema-form.json?templateVersion=' + environment.templateVersion;
            this.liveFormData.state = '';
            this.liveFormData.countryId = this.countryId;
            this.getJsonSchema(this.liveFormData);
        }
    };
    /**
     * @description to load checkout config based on selected country
     * @date 2020-10-07
     * @param {*} selectedCountry
     * @memberof AddressNewComponent
     */
    AddressNewComponent.prototype.loadCheckoutConfig = function (selectedCountry) {
        if (selectedCountry) {
            var countryCode = void 0;
            var selectedCountryCode = void 0;
            if (selectedCountry.associatedCountryCodeThree) {
                countryCode = selectedCountry.associatedCountryCodeThree;
            }
            else {
                countryCode = selectedCountry.isocodeThree;
            }
            if (countryCode) {
                this.checkoutConfig = this._checkoutConfigService.getSettings(countryCode, null);
                selectedCountryCode = countryCode;
            }
            if (!this.checkoutConfig.loadParticipatingCountries) {
                this.checkoutConfig = this._checkoutConfigService.getSettings(selectedCountry.isocodeThree, null);
                selectedCountryCode = selectedCountry.isocodeThree;
            }
            if (selectedCountryCode && this.checkoutConfig.displaySearchAddressSection) {
                this.messageService.setSelectedCountry(selectedCountryCode);
            }
        }
    };
    AddressNewComponent.prototype.getSubmitAddress = function () {
        var _this = this;
        this._appMessageService.getSubmitAddress().subscribe(function (isSubmit) {
            var element = _this.elementRef.nativeElement.getElementsByClassName('verify-address');
            if (element && element[0]) {
                element[0].click();
            }
        });
    };
    AddressNewComponent.prototype.setDisablePhonetypeField = function (jsonFormObject) {
        if (jsonFormObject && jsonFormObject.layout[3] && jsonFormObject.layout[3].items[1]) {
            jsonFormObject.layout[3].items[1].items[0].disabled = true;
        }
        return jsonFormObject;
    };
    AddressNewComponent.prototype.setContactType = function (address) {
        if (address) {
            if (this.checkoutConfig.removeMobileField) {
                this.jsonFormObject.data.phoneType = [];
                this.jsonFormObject.data.phoneType = ContactTypeValue.PHONE;
                this.jsonFormObject = this.setDisablePhonetypeField(this.jsonFormObject);
            }
            else if (this.checkoutConfig.removePhoneField) {
                this.jsonFormObject.data.phoneType = [];
                this.jsonFormObject.data.phoneType = ContactTypeValue.MOBILE;
                this.jsonFormObject = this.setDisablePhonetypeField(this.jsonFormObject);
            }
            else if (this.jsonFormObject.data.phoneType) {
                this.jsonFormObject.data.phoneType = ContactTypeValue.MOBILE;
            }
        }
        else {
            if (!this.jsonFormObject.data.phoneType && this.checkoutConfig.removeMobileField) {
                this.jsonFormObject.data.phoneType = [];
                this.jsonFormObject.data.phoneType = ContactTypeValue.PHONE;
                this.jsonFormObject = this.setDisablePhonetypeField(this.jsonFormObject);
            }
            else if (!this.jsonFormObject.data.phoneType && this.checkoutConfig.removePhoneField) {
                this.jsonFormObject.data.phoneType = [];
                this.jsonFormObject.data.phoneType = ContactTypeValue.MOBILE;
                this.jsonFormObject = this.setDisablePhonetypeField(this.jsonFormObject);
            }
            else if (!(this.jsonFormObject.data && this.jsonFormObject.data.phoneType)) {
                this.jsonFormObject.data.phoneType = ContactTypeValue.MOBILE;
            }
        }
    };
    return AddressNewComponent;
}());
export { AddressNewComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/address/address.component.ts.pre-build-optimizer.js